"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "orange", {
  enumerable: true,
  get: function get() {
    return _orange.default;
  }
});
Object.defineProperty(exports, "lightBlue", {
  enumerable: true,
  get: function get() {
    return _lightBlue.default;
  }
});
Object.defineProperty(exports, "oceanBlue", {
  enumerable: true,
  get: function get() {
    return _oceanBlue.default;
  }
});
Object.defineProperty(exports, "darkBlue", {
  enumerable: true,
  get: function get() {
    return _darkBlue.default;
  }
});
Object.defineProperty(exports, "lightRed", {
  enumerable: true,
  get: function get() {
    return _lightRed.default;
  }
});
Object.defineProperty(exports, "darkRed", {
  enumerable: true,
  get: function get() {
    return _darkRed.default;
  }
});
Object.defineProperty(exports, "pinkPurple", {
  enumerable: true,
  get: function get() {
    return _pinkPurple.default;
  }
});
Object.defineProperty(exports, "darkGreen", {
  enumerable: true,
  get: function get() {
    return _darkGreen.default;
  }
});
Object.defineProperty(exports, "lightGreen", {
  enumerable: true,
  get: function get() {
    return _lightGreen.default;
  }
});
Object.defineProperty(exports, "oceanGreen", {
  enumerable: true,
  get: function get() {
    return _oceanGreen.default;
  }
});
Object.defineProperty(exports, "darkGrey", {
  enumerable: true,
  get: function get() {
    return _darkGrey.default;
  }
});
Object.defineProperty(exports, "sidefishBlue", {
  enumerable: true,
  get: function get() {
    return _sidefishBlue.default;
  }
});
Object.defineProperty(exports, "hillewaereBlue", {
  enumerable: true,
  get: function get() {
    return _hillewaereBlue.default;
  }
});
Object.defineProperty(exports, "immothekerOrange", {
  enumerable: true,
  get: function get() {
    return _immothekerOrange.default;
  }
});
Object.defineProperty(exports, "elvas", {
  enumerable: true,
  get: function get() {
    return _elvas.default;
  }
});

var _orange = _interopRequireDefault(require("./orange"));

var _lightBlue = _interopRequireDefault(require("./lightBlue"));

var _oceanBlue = _interopRequireDefault(require("./oceanBlue"));

var _darkBlue = _interopRequireDefault(require("./darkBlue"));

var _lightRed = _interopRequireDefault(require("./lightRed"));

var _darkRed = _interopRequireDefault(require("./darkRed"));

var _pinkPurple = _interopRequireDefault(require("./pinkPurple"));

var _darkGreen = _interopRequireDefault(require("./darkGreen"));

var _lightGreen = _interopRequireDefault(require("./lightGreen"));

var _oceanGreen = _interopRequireDefault(require("./oceanGreen"));

var _darkGrey = _interopRequireDefault(require("./darkGrey"));

var _sidefishBlue = _interopRequireDefault(require("./sidefishBlue"));

var _hillewaereBlue = _interopRequireDefault(require("./hillewaereBlue"));

var _immothekerOrange = _interopRequireDefault(require("./immothekerOrange"));

var _elvas = _interopRequireDefault(require("./elvas"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }